<template>
    <section>
        <div class="contact_section4" style="padding-bottom: 130px;">
            <div class="mobile_con_wrap">
                <p style="font-size: 25px; font-weight: 700; color: black; margin-bottom: 20px;">직무별 인터뷰</p>
            </div>
            <Swiper :options="swiperOptions" ref="mySwiper" style="overflow: hidden; margin: 0 auto; padding-bottom: 100px;">
                <swiper-slide v-for="(item, index) in interview" :key="index" style="overflow: hidden;">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                        <img style="width: 100px; object-fit: contain; text-align: center; margin-right: 5px;" :src="require('@/assets/images/main_v2/mimote/'+ item.icon + '.png')" />
                        <div style="display: flex; flex-direction: column;">
                            <p style="color: black; font-size: 15px; font-weight: 700; line-height: 1.5;" v-html="changeRow(item.title)"></p>
                            <p style="color: black; font-size: 15px; font-weight: 400; line-height: 1.5;" v-html="changeRow(item.detail)"></p>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="mobile_con_wrap" style="display: flex; min-height: 426px">
                <div style="display: flex; flex-direction: column; align-items: flex-start;">
                    <p style="font-size: 25px; font-weight: 700; line-height: 1.5; margin-bottom: 20px; color: black;">
                        우리는<br>이런 일을 합니다
                    </p>
                    <div style="display: flex; margin-bottom: 50px;">
                        <div @click="activeIndex = index" class="inActive" :class="{isActive: activeIndex == index}" v-for="(item, index) in workPosition" :key="index">
                            {{item.name}}
                        </div>
                    </div>
                    <div data-aos="fade-right"
                        :data-aos-delay="0"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out">
                        <div v-for="(item, index) in positionDetail[workPosition[activeIndex].key]" :key="index" :style="{marginBottom: index != (positionDetail[workPosition[activeIndex].key].length - 1) ? '30px' : 0}">
                            <p style="color: black; font-size: 18px; font-weight: 700; line-height: 1.5;">{{item.title}}</p>
                            <p style="color: #5A5A5A; font-size: 15px; font-weight: 400; line-height: 1.5;">{{item.detail}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import {
  Swiper,
  SwiperSlide
} from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { ChevronDownIcon } from 'vue-feather-icons'
import SnackBar from '@/components/SnackBar.vue'
export default {
    components: {
        ChevronDownIcon,
        SnackBar,
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            interview: [
                {
                    'title': '기획팀 UI/UX Designer | 아리짱',
                    'detail': '사용자들의 불편함을 해소하고 최고의 경험을 제공하기 위해 끊임없이 팀원들 그리고 사용자와 소통하며 일을 하고 있어요.',
                    'icon': 'bona'
                },{
                    'title': '기획팀 UI/UX Designer | 서영님',
                    'detail': '브랜드에 필요한 디자인 기획과 제작을 담당하고 있습니다. 자율과 책임이라는 문화 속에서 무엇이든 시도해 볼 수 있어요.',
                    'icon': 'seoyoung'
                },{
                    'title': '기획팀 UI/UX Designer | 민지님',
                    'detail': '사용자에게 최적의 경험을 선물하는 가슴 뛰는 일을 하고있어요. 최고의 사용자 경험을 선사하기 위해 계속해서 고민해요.',
                    'icon': 'minji'
                },{
                    'title': '개발팀 Frontend Engineer | 제이슨',
                    'detail': '사용자가 저희 앱을 이용하면서 불편함을 느끼지 않도록 꼼꼼한 개발을 위해 계속해서 노력하고 있어요.',
                    'icon': 'jason'
                },{
                    'title': '개발팀 Frontend Engineer | 제이콥',
                    'detail': '버그 없는 최고의 웹 경험을 제공하기 위해 팀원들과 긍정적인 영향을 주고받으며 치열하게 일해요',
                    'icon': 'jacob'
                },{
                    'title': '개발팀 Frontend Engineer | 민규님',
                    'detail': '앱 개발을 하면서 프론트 경험을 쌓고있어요. 백엔드도 할 수 있게되서 풀스택 개발자가 되고 싶어요.',
                    'icon': 'mingyu'
                },{
                    'title': '개발팀 Backend Engineer | 현우님',
                    'detail': '팀에서 이것 저것 GAEBALSAEBAL 개발합니다. 베짱이를 꿈꾸고 있습니다.',
                    'icon': 'hyeonwoo'
                },{
                    'title': '개발팀 Backend Engineer | 상수님',
                    'detail': '팀원들에게 많은 도움과 피드백을 받고 있어요. 지금에 안주하기보다는 계속 도전하며 성장하고 있습니다.',
                    'icon': 'constant'
                }
            ],
            swiperOptions: {
                loop: true,
                loopedSlides: 8,
                // pagination: {
                // el: '.swiper-pagination',
                // clickable: true
                // },
                // effect: 'coverflow',
                speed: 8500,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false

                },
                centeredSlides: true,
                slidesPerView: '0.8',
                spaceBetween: 50,
            },
            activeIndex: 0,
            workPosition: [
                {
                    'name': '기획팀',
                    'key': 'plan'
                },{
                    'name': '콘텐츠팀',
                    'key': 'content'
                },{
                    'name': '개발팀',
                    'key': 'develope'
                }
            ],
            positionDetail: {
                'plan': [
                    {
                        'title': 'UI',
                        'detail': '사용자 경험 전략을 바탕으로 유저 인터페이스를 설계하고 디자인합니다. 서비스 전반에 대한 기능을 이해하고 지속적 으로 사용성 개선을 위해 시각화된 디자인을 제시합니다.'
                    },{
                        'title': 'UX',
                        'detail': '사용자 경험을 바탕으로 사용자가 보다 편리하고 쉬운 서비스 를 이용할 수 있게 끊임없이 고민합니다. 사용자의 니즈와 눈높이에 맞추어 문제를 발견하고 해결합니다.'
                    },
                ],
                'content': [
                    {
                        'title': '콘텐츠 확보',
                        'detail': ' 사용자들에게 다양한 학습의 기회를 제공하고자 양질의 교육 콘텐츠를 확보합니다. 사용자가 보다 편리하게 교육 콘텐츠를 경험할 수 있도록 콘텐츠 사업을 기획하고 전략을 구축합니다.'
                    },{
                        'title': '콘텐츠 전략',
                        'detail': '자사를 알리기 위한 전반적인 전략을 고민하고 탐구합니다. 자사가 지속적인 성장을 할 수 있도록 광고, 소셜, 영업 등을 통해 사용자들을 유지 및 확보하고자 노력합니다.'
                    },
                ],
                'develope': [
                    {
                        'title': 'Front End',
                        'detail': '데이터의 입, 출력을 통한 비즈니스 로직 구성과 사용자 인터 페이스에 대한 작업을 수행하며 사용자에게 시각적으로 보여 지는 모든 부분을 담당합니다'
                    },{
                        'title': 'Back End',
                        'detail': '사용자가 보지 못하는 영역인 서버나 데이터베이스를 관리하며 실질적으로 사용자들이 원하는 정보를 제공할 수 있도록 데이터를 가공하여 제공합니다.'
                    },
                ]
            }
        }
    },
    methods: {
        openLink(val) {
            window.open(val, '_blank')
        },
        changeRow(val) {
            return val.split('\n').join('<br />')
        },
        setIcon(val)  {
            return require('@/assets/images/main_v2/icon/'+ val.icon +'.svg')
        }
        // copy(val) {
        //     navigator.clipboard.writeText(val).then(()=> {
        //         this.$store.commit('SET_SNACK_BAR_INFO' , {
        //             text: '메일주소가 복사되었습니다.',
        //             icon: 'icon-check.svg',
        //             color: 'white',
        //             background: '#1C9CD3'
        //         })
        //         this.showSnackBar = true
        //     })
        // },
    }
    
}
</script>
<style>
    .contact_section4 {
        width: 100vw;
        background: white;
        object-fit: inherit;
    }
    .contact_section4 .swiper-wrapper {
        transition-timing-function: linear
    }
    .contact_section4 .inActive {
        padding: 4px 14px;
        color: #2C2C2C;
        font-weight: 700;
        font-size: 15px;
        border-radius: 100px;
        margin-right: 6px;
        cursor: pointer;
        transition: all 0.2s ease;
    }
    .contact_section4 .isActive {
        background: #1C9CD3;
        color: white
    }
</style>